export enum CatalogueType {
  Sales = 'sales',
  Semen = 'semen',
}
